<template>
  <div :class="{'w3-row': wideLayout}">
    <template v-if="user.customer.sources.data.length < 1 && !addCardDisplay && !chooseCardDisplay">
      <p>Add a Payment Method to complete purchase</p>
    </template>
    <template v-if="user.customer.sources.data.length > 0">
      <template v-if="chooseCardDisplay">
        <p>Highlight the card to use for this purchase</p>
      </template>
      <div v-for="(item, key, i) of user.customer.sources.data" :key="i">
        <template v-if="hasDefault() && !chooseCardDisplay && !addCardDisplay || user.customer.sources.data.length === 1 && !chooseCardDisplay && !addCardDisplay">
          <div class="w3-card w3-text-white" :class="item.selected ? 'selected' : ''" style="max-width:400px; margin:0 auto;" v-if="item.selected">
            <div style="background:#263238">
              <header class="w3-row w3-dark-blue-grey">
                <img src="../assets/images/cards/visa.png" v-if="item.brand === 'Visa'" />
                <img src="../assets/images/cards/mastercard.png" v-if="item.brand === 'MasterCard'" />
                <img src="../assets/images/cards/amex.png" v-if="item.brand === 'American Express'" />
                <img src="../assets/images/cards/discover.png" v-if="item.brand === 'Discover'" />
                <img src="../assets/images/cards/unknown.png" v-if="item.brand === 'Unknown'" />
              </header>
              <div class="w3-row">
                <div style="margin:30px auto 25px; font-size:30px;">xxxx xxxx xxxx {{item.last4}}</div>
                <div class="w3-left" style="font-size:8px; background:#333; padding:10px 3px 10px 8px;">ZIP</div>
                <div class="w3-left" style="font-style:italic; background:#333; padding:5px 15px 5px 0;">{{item.address_zip}}</div>
                <div class="w3-right" style="font-style:italic; background:#333; padding:5px 15px 5px 0;">{{item.exp_month}} / {{item.exp_year}}</div>
                <div class="w3-right" style="font-size:8px; background:#333; padding:5px 5px 5px 10px;">VALID<br/>THRU</div>
              </div>
            </div>
          </div>
        </template>
        <template v-if="chooseCardDisplay">
          <div class="w3-card w3-text-white" :class="item.selected ? 'selected' : ''" style="max-width:400px; margin:0 auto 8px;">
            <div style="background:#263238">
              <header class="w3-row w3-dark-blue-grey">
                <img src="../assets/images/cards/visa.png" v-if="item.brand === 'Visa'" />
                <img src="../assets/images/cards/mastercard.png" v-if="item.brand === 'MasterCard'" />
                <img src="../assets/images/cards/amex.png" v-if="item.brand === 'American Express'" />
                <img src="../assets/images/cards/discover.png" v-if="item.brand === 'Discover'" />
                <img src="../assets/images/cards/unknown.png" v-if="item.brand === 'Unknown'" />
                <!-- TODO: Move to another place manage cards -->
                <div class="w3-right" style="margin:8px 0; font-size:12px;">
                  <!-- TODO maybe use default payments -->
                  <!-- <button @click.prevent="setDefaultCard(item.id)" class="w3-button w3-dark-grey rightButton" :class="{'w3-green': checkDefault(item.id)}"><template v-if="checkDefault(item.id)">IS DEFAULT</template><template v-if="!checkDefault(item.id)">SET DEFAULT</template></button> -->
                  <button @click.prevent="removeCard(item.id)" class="w3-button w3-red" style="padding:6px 8px; margin-right:8px"><font-awesome-icon icon="trash"></font-awesome-icon></button>
                </div>
              </header>
              <div class="w3-row" style="font-family:'Open Sans'" @click="selectCard(item.id)">
                <div style="margin:30px auto 25px; font-size:30px;">xxxx xxxx xxxx {{item.last4}}</div>

                <div class="w3-left" style="font-size:8px; background:#333; padding:10px 3px 10px 8px;">ZIP</div>
                <div class="w3-left" style="font-style:italic; background:#333; padding:5px 15px 5px 0;">{{item.address_zip}}</div>

                <div class="w3-right" style="font-style:italic; background:#333; padding:5px 15px 5px 0;">{{item.exp_month}} / {{item.exp_year}}</div>
                <div class="w3-right" style="font-size:8px; background:#333; padding:5px 5px 5px 10px;">VALID<br/>THRU</div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </template>

    <template v-if="addCardDisplay">
      <div class="w3-card w3-dark-blue-grey">
        <header class="w3-container w3-text-white" style="padding:0 0 0 12px;">
          <h5 class="w3-left" style="margin:6px 0 2px;"><font-awesome-icon icon="credit-card" style="margin-right:8px;"></font-awesome-icon>New Card</h5>
        </header>
        <!-- Multi field form instead? -->
        <div class='credit-card-inputs' :class='{ complete }'>
          <div class="w3-row" style="padding:5px 5px 0;">
            <div class="w3-rest" style="margin-bottom:5px;" >
              <card-number class='stripe-element card-number'
                ref='cardNumber'
                :stripe='stripe'
                :options='options'
                @change='number = $event.complete'
              />
            </div>
          </div>
          <div class="w3-row" style="padding:0 5px;">
            <div class="w3-half" style="margin-bottom:5px; padding-right:5px;">
              <card-expiry class='stripe-element card-expiry'
                ref='cardExpiry'
                :stripe='stripe'
                :options='options'
                @change='expiry = $event.complete'
              />
            </div>
            <div class="w3-half" style="margin-bottom:5px;">
              <card-cvc class='stripe-element card-cvc'
                ref='cardCvc'
                :stripe='stripe'
                :options='options'
                @change='cvc = $event.complete'
              />
            </div>
          </div>
          <div class="w3-row" style="padding:0 5px 5px;">
            <div class="w3-rest">
              <postal-code class='stripe-element postal-code'
                ref='postalCode'
                :stripe='stripe'
                :options='options'
                @change='zip = $event.complete'
              />
            </div>
          </div>
        </div>
      </div>
    </template>

    <template v-if="chooseCardDisplay">
      <button class="w3-button w3-block w3-green" style="margin-top:8px;" @click="saveSelectedCard();">Save Selected Card</button>
    </template>
    <template v-if="addCardDisplay">
      <button class="w3-button w3-block w3-green" style="margin-top:8px;" :disabled='!complete || loadingPayMethods' @click="addCard()"><template v-if="loading"><div class="loader"></div></template><template v-else>Add Card</template></button>
    </template>
    <template v-if="!chooseCardDisplay && user.customer.sources.data.length > 1">
      <button class="w3-button w3-block w3-dark-blue" style="margin-top:8px;" @click="chooseCardDisplay = true; addCardDisplay = false">Choose Saved Card</button>
    </template>
    <template v-if="!addCardDisplay">
      <button class="w3-button w3-block w3-blue" style="margin-top:8px;" @click="addCardDisplay = true; chooseCardDisplay = false">Add New Card</button>
    </template>

    <button v-if="addCardDisplay" class="w3-button w3-block w3-red" style="margin-top:8px;" @click="addCardDisplay = false">Cancel</button>
    <button v-if="chooseCardDisplay" class="w3-button w3-block w3-red" style="margin-top:8px;" @click="chooseCardDisplay = false">Cancel</button>
  </div>
</template>

<script>
import { CardNumber, CardExpiry, CardCvc, PostalCode, createToken } from 'vue-stripe-elements-plus'
import axios from 'axios'
import { mapState } from 'vuex';

export default {
  name: 'paymentMethods',
  computed: mapState([
    'user',
    'loading',
    'loadingPayMethods'
  ]),
  props: {
    wideLayout: false
  },
  data () {
    return {
      addCardDisplay: false,
      chooseCardDisplay: false,
      // stripe: 'pk_test_azNkDEj6cZZ5TIp54elHDaWM', // Test
      stripe: 'pk_live_MDEfx0FB1AMRBH6o7D8DHPbv',
      options: {
        style: {
          base: {
            color: '#fafafa',
            fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
            fontSmoothing: 'antialiased',
            fontSize: '16px',
            '::placeholder': {
              color: '#999'
            }
          },
          invalid: {
            color: '#fa755a',
            iconColor: '#fa755a'
          }
        }
      },
      complete: false,
      number: false,
      expiry: false,
      cvc: false,
      zip: false
    }
  },
  components: { CardNumber, CardExpiry, CardCvc, PostalCode },
  mounted() {
    this.$store.commit('setLoading', false)
    if (this.user.customer.sources.data.length === 1) {
      this.selectCard(this.user.customer.sources.data[0].id)
    }
  },
  methods: {
    addCard() {
      this.$store.commit('setLoading', true)
      if (this.user.customer && this.user.customer.sources.data.length > 0) {
        createToken().then((data) => {
          let postData = {
            email: this.user.email,
            sourceid: data.token.id,
            customerid: this.user.customer.id
          }
          axios.post('https://us-central1-daytona-local.cloudfunctions.net/addSource', postData).then((response) => {
            this.$store.dispatch('getUserData', this.user.uid).then(() => {
              this.selectCard(response.data.sourceid)
              this.addCardDisplay = false
              this.$store.commit('setLoading', false)
            })
          }).catch(error => {
            this.$store.commit('setLoading', false)
          })
        })
      } else {
        createToken().then(data => {
          let postData = {
            email: this.user.email,
            source: data.token.id
          }
          axios.post('https://us-central1-daytona-local.cloudfunctions.net/createStripeCustomer', postData).then((response) => {
            this.$store.dispatch('getUserData', this.user.uid).then(() => {
              this.selectCard(response.data.sourceid)
              this.addCardDisplay = false
              this.$store.commit('setLoading', false)
            })
          }).catch(error => {
            this.$store.commit('setLoading', false)
          })
        })
      }
    },
    removeCard(id) {
      this.$store.commit('setLoading', true)
      let postData = {
        customerid: this.user.customer.id,
        email: this.user.email,
        sourceid: id
      }
      axios.post('https://us-central1-daytona-local.cloudfunctions.net/removeSource', postData).then(response => {
        this.$store.dispatch('getUserData', this.user.uid).then(() => {
          this.$store.commit('setLoading', false)
        })
      }).catch(error => {
        this.$store.commit('setLoading', false)
      })
    },
    selectCard(id) {
      if (this.user.customer.sources.data.length > 0) {
        for (let source of this.user.customer.sources.data) {
          console.log(source)
          if (source.id === id) {
            source.selected = true
            this.saveSelectedCard()
            return
          } else {
            source.selected = false
          }
        }
      }
    },
    saveSelectedCard() {
      let user = this.user
      this.$store.dispatch('updateUserData', user)
      this.chooseCardDisplay = false
    },
    hasDefault() {
      if (this.user.customer.default_source === '') {
        return false
      } else {
        return true
      }
    },
    checkDefault(id) {
      if (id === this.user.customer.default_source) {
        return true
      } else {
        return false
      }
    },
    update () {
      this.complete = this.number && this.expiry && this.cvc && this.zip
      // field completed, find field to focus next
      if (this.number) {
        if (!this.expiry) {
          this.$refs.cardExpiry.focus()
        } else if (!this.cvc) {
          this.$refs.cardCvc.focus()
        } else if (!this.zip) {
          this.$refs.postalCode.focus()
        }
      } else if (this.expiry) {
        if (!this.cvc) {
          this.$refs.cardCvc.focus()
        } else if (!this.zip) {
          this.$refs.postalCode.focus()
        } else if (!this.number) {
          this.$refs.cardNumber.focus()
        }
      } else if (this.zip) {
        if (!this.number) {
          this.$refs.cardNumber.focus()
        } else if (!this.cvc) {
          this.$refs.cardCvc.focus()
        } else if (!this.expiry) {
          this.$refs.cardExpiry.focus()
        }
      }
    }
  },
  watch: {
    number () { this.update() },
    expiry () { this.update() },
    cvc () { this.update() },
    zip () { this.update() }
  }
}
</script>

<style>
.StripeElement {
  height: 40px;
  padding: 10px 12px;
  background:#424242;
  border:1px solid #333;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}
header.w3-row img {max-height:30px; margin:8px; float:left;}
.rightButton {padding:6px 15px !important; margin:0 5px 0 0;}
.selected {border:2px solid #43a047}
</style>
